import { measuredUsingConfigFor as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

//defines which balance is used for which masses.
const getMeasuredUsingConfig = (prefix: string) => {
  const constantDryMassPrefix = `${prefix}.Masses.MeasuredWashedConstantDryMass`;
  const dryBalance = wrap(`${constantDryMassPrefix}.Equipment.DryMassBalance`);
  return {
    [`${constantDryMassPrefix}.DryingTray.ContainerMass`]: dryBalance,
    [`${constantDryMassPrefix}.DryingTray.DryMassReadings.DrySoilAndContainerMass`]: dryBalance,
  };
};

export default getMeasuredUsingConfig;
